// 异常类型：1-异常商品，2-异常包裹
export const EXCEPTION_TYPE = {
  PRODUCT: 1,
  PARCEL: 2,
};

// 回复状态：0-未回复，1-已回复
export const EXCEPTION_STATUS = {
  UNREPLIED: 0,
  REPLIED: 1,
};


// 默认登记人
export const DEFAULT_REGISTER_NAME = "龙荷英";

// 杭州仓、西子仓编码，仓库列表未加载时兜底
export const DEFAULT_WAREHOUSE_OPTIONS = [
  { wareCode: "1513770467071086592", wareName: "杭州仓" },
  { wareCode: "1812673211347738624", wareName: "西子仓" },
];

// 状态筛选项
export const STATUS_OPTIONS = [
  { label: "全部", value: "" },
  { label: "未回复", value: EXCEPTION_STATUS.UNREPLIED },
  { label: "已回复", value: EXCEPTION_STATUS.REPLIED },
];

/**
 * 列表/日志时间展示为 YYYY-MM-DD HH:mm
 */
export function formatDateTime(value) {
  if (!value) {
    return "-";
  }
  const text = String(value);
  return text.length >= 16 ? text.slice(0, 16) : text;
}

/**
 * 按当前 Tab 生成列表列
 */
export function getColumns(exceptionType) {
  const codeTitle = exceptionType === EXCEPTION_TYPE.PARCEL ? "运单号" : "SKU";
  return [
    {
      title: "时间",
      dataIndex: "createTime",
      key: "createTime",
      width: 160,
      customRender: (text) => formatDateTime(text),
    },
    {
      title: "登记人",
      dataIndex: "registerName",
      key: "registerName",
      width: 100,
    },
    {
      title: "发注书名",
      dataIndex: "purchaseBook",
      key: "purchaseBook",
      ellipsis: true,
      width: 160,
    },
    {
      title: codeTitle,
      dataIndex: "bizCode",
      key: "bizCode",
      width: 180,
    },
    {
      title: "异常说明",
      dataIndex: "exceptionDesc",
      key: "exceptionDesc",
      ellipsis: true,
      width: 240,
    },
    {
      title: "异常图片",
      dataIndex: "pics",
      key: "pics",
      width: 90,
      scopedSlots: {
        customRender: "pics",
      },
    },
    {
      title: "需回复人",
      dataIndex: "replyUserName",
      key: "replyUserName",
      width: 100,
    },
    {
      title: "回复结果",
      dataIndex: "replyResult",
      key: "replyResult",
      ellipsis: true,
      width: 180,
      customRender: (text) => {
        return text || "-";
      },
    },
    {
      title: "回复时间",
      dataIndex: "replyTime",
      key: "replyTime",
      width: 160,
      customRender: (text) => formatDateTime(text),
    },
    {
      title: "状态",
      dataIndex: "statusName",
      key: "statusName",
      width: 90,
    },
    {
      title: "操作",
      dataIndex: "action",
      key: "action",
      width: 240,
      scopedSlots: {
        customRender: "action",
      },
    },
  ];
}

/**
 * 操作日志列
 */
export const logColumns = [
  {
    title: "操作时间",
    dataIndex: "operateTime",
    key: "operateTime",
    customRender: (text) => formatDateTime(text),
  },
  {
    title: "操作内容",
    dataIndex: "operateContent",
    key: "operateContent",
  },
  {
    title: "操作人",
    dataIndex: "operatorName",
    key: "operatorName",
  },
];
